<card-alerte *ngIf="listeAlertes?.length" [niveau]="niveauAlerteProfil" [isCard]="true">
    <preview-alerte *ngFor="let alerte of listeAlertes" [alerte]="alerte"></preview-alerte>
</card-alerte>

<ng-container *ngIf="!user.rgpdSuspendu">
    <list-view *ngIf="listeComptesBancaires" [liste]="listeComptesBancaires"></list-view>
    <list-view *ngIf="listeCartesPaiement" [liste]="listeCartesPaiement"></list-view>
</ng-container>
